import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectCurrentCertificationAction } from '../../../ReduxStorage/Certification/CurrentCertificationAction/selectors';
import { LoadableClassCertification } from './ClassCertification/loadable';
import { LoadableCertificateAppearance } from './CertificateAppearance/loadable';
import { LoadableCertificationSetup } from './CourseCertificationSetup/loadable';

export class CourseCertificationPage extends React.PureComponent {
  static propTypes = {
    currentAction: PropTypes.string.isRequired,
  };

  render() {
    const { currentAction } = this.props;
    const mountElem = document.getElementById('course-admin-container');
    if (mountElem) {
      switch (currentAction) {
        case 'students':
          return ReactDOM.createPortal(
            <LoadableClassCertification />,
            mountElem
          );
        case 'appearance':
          return ReactDOM.createPortal(
            <LoadableCertificateAppearance />,
            mountElem
          );
        case 'settings':
          return ReactDOM.createPortal(
            <LoadableCertificationSetup />,
            mountElem
          );
        default:
          break;
      }
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    currentAction: selectCurrentCertificationAction(state),
  };
};

export const MountableCourseCertificationPage = connect(mapStateToProps)(
  CourseCertificationPage
);
